import type { SupportedLanguage } from './index';

export type PluralCategory = 'one' | 'few' | 'many' | 'other';

/**
 * Cardinal plural selection for Tonyte's supported locales.
 *
 * React Native/Hermes builds do not consistently ship Intl.PluralRules.
 * Keeping these small CLDR-equivalent rules in-app avoids a large Intl
 * polyfill and makes plural selection deterministic on iOS and Android.
 */
export function selectPluralCategory(language: SupportedLanguage, count: number): PluralCategory {
  if (!Number.isFinite(count)) return 'other';

  if (language === 'ru') {
    if (!Number.isInteger(count)) return 'other';
    const absolute = Math.abs(count);
    const mod10 = absolute % 10;
    const mod100 = absolute % 100;
    if (mod10 === 1 && mod100 !== 11) return 'one';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'few';
    if (mod10 === 0 || mod10 >= 5 || (mod100 >= 11 && mod100 <= 14)) return 'many';
    return 'other';
  }

  if (language === 'fr') return count === 0 || count === 1 ? 'one' : 'other';
  return count === 1 ? 'one' : 'other';
}
